import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";

export const metadataDealsFields = defineFieldConfigMap({
  // FIELD: contract_status — derived "Contract" list column. Shows the
  // furthest-along status among contracts linked to this deal (contracts.deal_id),
  // or "None". Read-only + excluded from the API; the value is computed in
  // getFieldValue → resolveDealContractStatus from the nested `contractsCollection`
  // that GetDeals selects. List-only (no card/detail section → no detail-query
  // coverage requirement).
  contract_status: {
    type: "text",
    label: "Contract",
    sortable: false,
    filterable: false,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    isReadOnlyDerived: true,
    readOnlyReason: "Furthest-along status among contracts linked to this deal.",
    excludeFromApi: true,
    dataLineage: {
      kind: "derived",
      sourceField: "contractsCollection",
      notes:
        "Computed by getFieldValue → resolveDealContractStatus from the deal's linked contracts (contracts.deal_id).",
    },
    width: 140,
    minWidth: 110,
    maxWidth: 200,
    icon: "FileSignature",
    allowedRoles: ["wtc_employee", "wtc_admin"],
  },
  // FIELD: slack_channel_id — the deal's Slack PROJECT channel. Rendered as a
  // friendly "🗂️ Open channel" link (see field-display-renderer.tsx). Internal
  // (staff only); display-only — the channel is set by "Make Project Channel".
  slack_channel_id: {
    type: "text",
    label: "Project Channel",
    mobileDetailSectionId: "details",
    sortable: false,
    filterable: false,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: false,
    width: 160,
    minWidth: 120,
    maxWidth: 220,
    icon: "MessageSquare",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    graphqlSelector: "slack_channel_id",
  },
  // FIELD: tags
  tags: {
    type: "tags",
    label: "Tags",
    sortable: false,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    formSpan: 3,
    filterType: "contains",
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    tagsConfig: {
      commonTags: [],
      maxTags: 20,
      allowCustom: true,
    },
    placeholder: "Add tags",
    icon: "Tag",
    groupable: true,
    allowedRoles: ["wtc_employee", "wtc_admin"],
    showOnCard: true,
    cardSpan: 3,
    mobileDetailSectionId: "details",
    savedViewMembership: ["not-followed-up-this-week"],
  },
  // FIELD: description
  description: {
    type: "textarea",
    label: "Description",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    bulkEditable: true,
    formSpan: 3,
    width: 300,
    minWidth: 200,
    maxWidth: 500,
    placeholder: "Enter deal description",
    icon: "FileText",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "details",
  },
  // FIELD: notes
  notes: {
    type: "textarea",
    label: "Notes",
    sortable: false,
    filterable: false,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 300,
    minWidth: 200,
    maxWidth: 500,
    placeholder: "Internal notes",
    icon: "StickyNote",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    mobileDetailSectionId: "details",
  },
});
